
/*
  This file is auto-generated.
  By commands: 'npx hardhat deploy' or 'npx hardhat node'
*/
export const ConfidentialTranscriptAddresses = { 
  "11155111": { address: "0xe12d8Ff571f99DD38184D9c40b31CFfd0525Af6b", chainId: 11155111, chainName: "sepolia" }
};
